import { EVENTS } from 'src/constants/webSocketConsts/events';
import {
  loadPortalSettingsAction,
  removePortalSettingsAction,
} from 'src/store/settings/actions';
import { PortalSettings } from 'src/constants/dataTypes';

const portalSettingsHandler = (event: string, items: Array<PortalSettings>) => {
  if (items.length === 0) {
    return null;
  }

  switch (event) {
    case EVENTS.REMOVE:
      return removePortalSettingsAction(items);
    case EVENTS.INSERT:
    case EVENTS.MODIFY:
      return loadPortalSettingsAction(items);
    default:
      break;
  }
  return null;
};

export default portalSettingsHandler;
